export default "__VITE_ASSET__BAerhYnD__"